module.exports = __webpack_public_path__ + "assets/img/desc-03-69dfbea5.png";